<template>
    <div>
      <div class="card">
        <div class="card-body">
          <Filtro @registroImportadoAstecFiltrados="atualizarFiltro"  />
        </div>
      </div>
      <div>
        <div class="text-center" v-if="loadingGridImportacao === true">
          <b-spinner class="ms-2" variant="primary"></b-spinner>
        </div>
        <div class="card" v-if="loadingGridImportacao === false">
          <div class="card-body">
            <Grid  :items="lotesImportadosListados" @registroImportadoAstecFiltrados="atualizarFiltro" />
          </div>
        </div>
      </div>
  
    </div>
  </template>
  
  <script>
  import Filtro from "@/components/astec/loteImportacao/filtroRegistrosImportados";
  import Grid from "@/components/astec/loteImportacao/gridRegistrosImportados";
  import clienteRuralMixin from "@/tools/mixins/clienteRuralMixin.js";
  
  export default {
    mixins: [clienteRuralMixin],
    components: {
      Grid,
      Filtro
    },
    data() {
      return {
        filtro: {},
        loadingGridImportacao: null,
        lotesImportadosListados: [],
  
      };
    },
  
    // created() {
    //   this.$store.commit("PARAMETROS_PROJETO_ASTEC", null);
    // },
  
    methods: {
      async atualizarFiltro(filtro, callback) {
        this.loadingGridImportacao = true;
        console.log("CHEGOU AQUI", filtro)
        // var objFiltrado = await this.buscarItens(filtro);
        var objFiltrado = [
          { 
            ST_PROJETO: "EXPORTADO", 
            nr_plano: 1, 
            sq_produtor: "Produtor Rural", 
            sq_produtor2: "744.639.509-53", 
            sq_linha_credito: "PRONAMP", 
            sq_modalidade_seguro: "PROAGRO", 
            cd_safra: "2024/2024", 
            astec: "Sim", 
            vl_orcado: "32465.99", 
            vl_astec: "649.32", 
            qt_area : "7.48"
          },
          { 
            ST_PROJETO: "COMPLETO", 
            nr_plano: 1, 
            sq_produtor: "Produtor Rural", 
            sq_produtor2: "744.639.509-53", 
            sq_linha_credito: "PRONAMP", 
            sq_modalidade_seguro: "PROAGRO", 
            cd_safra: "2024/2024", 
            astec: "Sim", 
            vl_orcado: "32465.99", 
            vl_astec: "649.32", 
            qt_area : "7.48"
          },
          { 
            ST_PROJETO: "ELABORADO", 
            nr_plano: 1, 
            sq_produtor: "Produtor Rural", 
            sq_produtor2: "744.639.509-53", 
            sq_linha_credito: "PRONAMP", 
            sq_modalidade_seguro: "PROAGRO", 
            cd_safra: "2024/2024", 
            astec: "Sim", 
            vl_orcado: "32465.99", 
            vl_astec: "649.32", 
            qt_area : "7.48"
          },
          { 
            ST_PROJETO: "INCOMPLETO", 
            nr_plano: 1, 
            sq_produtor: "Produtor Rural", 
            sq_produtor2: "744.639.509-53", 
            sq_linha_credito: "PRONAMP", 
            sq_modalidade_seguro: "PROAGRO", 
            cd_safra: "2024/2024", 
            astec: "Sim", 
            vl_orcado: "32465.99", 
            vl_astec: "649.32", 
            qt_area : "7.48"
          },
          { 
            ST_PROJETO: "COMPLETO", 
            nr_plano: 1, 
            sq_produtor: "Produtor Rural", 
            sq_produtor2: "744.639.509-53", 
            sq_linha_credito: "PRONAMP", 
            sq_modalidade_seguro: "PROAGRO", 
            cd_safra: "2024/2024", 
            astec: "Sim", 
            vl_orcado: "32465.99", 
            vl_astec: "649.32", 
            qt_area : "7.48"
          },
          { 
            ST_PROJETO: "COMPLETO", 
            nr_plano: 1, 
            sq_produtor: "Produtor Rural", 
            sq_produtor2: "744.639.509-53", 
            sq_linha_credito: "PRONAMP", 
            sq_modalidade_seguro: "PROAGRO", 
            cd_safra: "2024/2024", 
            astec: "Sim", 
            vl_orcado: "32465.99", 
            vl_astec: "649.32", 
            qt_area : "7.48"
          },
          { 
            ST_PROJETO: "EXPORTADO", 
            nr_plano: 1, 
            sq_produtor: "Produtor Rural", 
            sq_produtor2: "744.639.509-53", 
            sq_linha_credito: "PRONAMP", 
            sq_modalidade_seguro: "PROAGRO", 
            cd_safra: "2024/2024", 
            astec: "Sim", 
            vl_orcado: "32465.99", 
            vl_astec: "649.32", 
            qt_area : "7.48"
          },
          { 
            ST_PROJETO: "EXPORTADO", 
            nr_plano: 1, 
            sq_produtor: "Produtor Rural", 
            sq_produtor2: "744.639.509-53", 
            sq_linha_credito: "PRONAMP", 
            sq_modalidade_seguro: "PROAGRO", 
            cd_safra: "2024/2024", 
            astec: "Sim", 
            vl_orcado: "32465.99", 
            vl_astec: "649.32", 
            qt_area : "7.48"
          },
          { 
            ST_PROJETO: "EXPORTADO", 
            nr_plano: 1, 
            sq_produtor: "Produtor Rural", 
            sq_produtor2: "744.639.509-53", 
            sq_linha_credito: "PRONAMP", 
            sq_modalidade_seguro: "PROAGRO", 
            cd_safra: "2024/2024", 
            astec: "Sim", 
            vl_orcado: "32465.99", 
            vl_astec: "649.32", 
            qt_area : "7.48"
          },
          { 
            ST_PROJETO: "INCOMPLETO", 
            nr_plano: 1, 
            sq_produtor: "Produtor Rural", 
            sq_produtor2: "744.639.509-53", 
            sq_linha_credito: "PRONAMP", 
            sq_modalidade_seguro: "PROAGRO", 
            cd_safra: "2024/2024", 
            astec: "Sim", 
            vl_orcado: "32465.99", 
            vl_astec: "649.32", 
            qt_area : "7.48"
          },

        ];
        this.lotesImportadosListados = objFiltrado;
        this.loadingGridImportacao = false;
        if (typeof callback === 'function') {
            callback();
          }
          
      },
  
    }
  };
  </script>